import { Scale, Subtract, Total } from "@pdfking/math"
import { PlotFunction } from "@pdfking/renderer-api"

import { PALETTE } from "#constants"
import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { CaptionText } from "../CaptionText"
import { PictureCover } from "../PictureCover"
import { YearColumns } from "../YearColumns"

/** Hooge, a poster calendar: all picture, the year big at its head, its
 * months a column each on a card of paper, their days on the rows of their
 * weekdays, the weekdays' initials down its left, a rule between each; the
 * contact at its foot. */
export const Hooge: CalendarDesign = {
  cover: PictureCover({}),
  page: ({ body, contact, gap, language, outer, page, short, year }) => {
    const year_height = Scale(short, 0.1)
    const card = Slice.top(body, year_height, gap)[1]
    return [
      // The year over the picture, and a card of paper carved out of it down
      // over the contact, so it reads off the picture too
      Area.picture(page, "year", false, [
        ...CaptionText(Slice.top(outer, year_height)[0], `${year}`),
        {
          enum: PlotFunction.PLOT_RECT,
          fill_color: PALETTE.paper,
          position: {
            ...card,
            height: Subtract(Total(card.y, card.height, gap), outer.y),
            y: outer.y,
          },
        },
      ]),
      ...YearColumns({ box: card, gap, language, title: Scale(short, 0.025), year }),
      Area.footer(contact),
    ]
  },
  pages: "year",
}
